import { render } from "./edit_status_form.vue?vue&type=template&id=994bc84e"
import script from "./edit_status_form.js?vue&type=script&lang=js"
export * from "./edit_status_form.js?vue&type=script&lang=js"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__